var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isOpen
    ? _c("div", { staticClass: "c-price-offer-modal" }, [
        _c("div", {
          staticClass: "c-price-offer-modal__backdrop",
          on: { click: _vm.close },
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-price-offer-modal__dialog",
            attrs: { role: "dialog", "aria-modal": "true" },
          },
          [
            _c(
              "button",
              {
                staticClass: "c-price-offer-modal__close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("PriceOffer.Modal.close"),
                },
                on: { click: _vm.close },
              },
              [
                _c("i", {
                  staticClass: "ico ico-close",
                  attrs: { "aria-hidden": "true" },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-price-offer-modal__header" }, [
              _c("div", { staticClass: "c-price-offer-modal__title" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("PriceOffer.Modal.title")) +
                    "\n            "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "c-price-offer-modal__subtitle" }, [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("PriceOffer.Modal.subtitle")) +
                    "\n            "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-price-offer-modal__content" }, [
              _c("div", { staticClass: "c-price-offer-modal__search" }, [
                _c(
                  "div",
                  { staticClass: "c-price-offer-modal__search-input" },
                  [
                    _c("i", {
                      staticClass: "ico ico-search",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.search,
                          expression: "search",
                        },
                      ],
                      staticClass: "c-form__input",
                      attrs: {
                        type: "text",
                        placeholder: _vm.$t(
                          "PriceOffer.Modal.searchPlaceholder"
                        ),
                      },
                      domProps: { value: _vm.search },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.search = $event.target.value
                        },
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "c-btn c-btn--ghost c-price-offer-modal__create-trigger",
                    class: { "is-active": _vm.isCreateFormVisible },
                    attrs: { type: "button" },
                    on: { click: _vm.toggleCreateForm },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("PriceOffer.Modal.createTrigger")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.isCreateFormVisible
                ? _c(
                    "form",
                    {
                      staticClass: "c-price-offer-modal__create",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.createOffer.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-price-offer-modal__create-item is-number",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "c-price-offer-modal__label",
                              attrs: { for: "priceOfferNumber" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(
                                    _vm.$t("PriceOffer.Modal.numberLabel")
                                  ) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            staticClass: "c-form__input",
                            attrs: {
                              type: "text",
                              id: "priceOfferNumber",
                              title: _vm.$t("PriceOffer.Modal.numberHint"),
                              disabled: "",
                            },
                            domProps: { value: _vm.nextNumber },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "c-price-offer-modal__create-item is-name",
                        },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "c-price-offer-modal__label",
                              attrs: { for: "priceOfferName" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.$t("PriceOffer.Modal.nameLabel")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newName,
                                expression: "newName",
                              },
                            ],
                            ref: "nameInput",
                            staticClass: "c-form__input",
                            class: { error: _vm.createError },
                            attrs: {
                              type: "text",
                              id: "priceOfferName",
                              placeholder: _vm.$t(
                                "PriceOffer.Modal.namePlaceholder"
                              ),
                              maxlength: "255",
                            },
                            domProps: { value: _vm.newName },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.newName = $event.target.value
                              },
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "c-btn c-price-offer-modal__create-submit",
                          class: { "is-loading": _vm.isCreating },
                          attrs: { type: "submit", disabled: _vm.isCreating },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("PriceOffer.Modal.createSubmit")) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.createError
                        ? _c(
                            "div",
                            { staticClass: "c-price-offer-modal__error" },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.createError) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isLoading
                ? _c(
                    "div",
                    {
                      staticClass: "c-price-offer-modal__list is-skeleton",
                      attrs: {
                        "aria-busy": "true",
                        "aria-label": _vm.$t("PriceOffer.Modal.loading"),
                      },
                    },
                    _vm._l(_vm.skeletonRows, function (n) {
                      return _c(
                        "div",
                        {
                          key: `skeleton-${n}`,
                          staticClass: "c-price-offer-modal__row",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("span", {
                            staticClass: "c-price-offer-modal__box",
                          }),
                          _vm._v(" "),
                          _vm._m(0, true),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "c-price-offer-modal__line is-date",
                          }),
                        ]
                      )
                    }),
                    0
                  )
                : _vm.filteredOffers.length
                ? _c(
                    "div",
                    { staticClass: "c-price-offer-modal__list" },
                    _vm._l(_vm.filteredOffers, function (offer) {
                      return _c(
                        "label",
                        {
                          key: offer.id,
                          staticClass: "c-price-offer-modal__row",
                          class: { "is-selected": _vm.isSelected(offer.id) },
                        },
                        [
                          _c("input", {
                            staticClass: "c-price-offer-modal__checkbox",
                            attrs: { type: "checkbox" },
                            domProps: {
                              value: offer.id,
                              checked: _vm.isSelected(offer.id),
                            },
                            on: {
                              change: function ($event) {
                                return _vm.toggle(offer.id)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm._m(1, true),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "c-price-offer-modal__row-offer" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "c-price-offer-modal__row-number",
                                },
                                [_vm._v(_vm._s(offer.number))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticClass: "c-price-offer-modal__row-name",
                                },
                                [_vm._v(_vm._s(offer.name))]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass: "c-price-offer-modal__row-customer",
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(offer.customer_name) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "span",
                            { staticClass: "c-price-offer-modal__row-date" },
                            [_vm._v(_vm._s(offer.created))]
                          ),
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "c-price-offer-modal__list" }, [
                    _c("div", { staticClass: "c-price-offer-modal__empty" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.search
                              ? _vm.$t("PriceOffer.Modal.noResults")
                              : _vm.$t("PriceOffer.Modal.empty")
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "c-price-offer-modal__footer" }, [
              _c(
                "button",
                {
                  staticClass: "c-btn c-btn--ghost",
                  attrs: { type: "button" },
                  on: { click: _vm.close },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$t("PriceOffer.Modal.cancel")) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "c-btn c-price-offer-modal__submit",
                  class: { "is-loading": _vm.isSubmitting },
                  attrs: {
                    type: "button",
                    disabled: _vm.isSubmitting || !_vm.hasChanges,
                  },
                  on: { click: _vm.submit },
                },
                [
                  _c("i", {
                    staticClass: "ico ico-plus is-on-left",
                    attrs: { "aria-hidden": "true" },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("PriceOffer.Modal.submit"))),
                  ]),
                ]
              ),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-price-offer-modal__row-offer" }, [
      _c("span", { staticClass: "c-price-offer-modal__line is-number" }),
      _vm._v(" "),
      _c("span", { staticClass: "c-price-offer-modal__line is-name" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "c-price-offer-modal__box" }, [
      _c("i", {
        staticClass: "ico ico-tick",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }